

import {siteOrigin, backendUrl} from "../../globalConfig";



export const getDashboardGetOneUserPointData = async (elementId: number, symbol: string, days: number) => {
    const params = new URLSearchParams({
        element_id: elementId.toString(),
        symbol: symbol,
        days: days.toString()
    }).toString()
    return await fetch(backendUrl+'/dashboard/dashboard_get_one_user_point_data?' + params, {
        method: 'GET',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': siteOrigin
        }
    })
        .then(r => r.json())
    // return resultArray
}